function toggleStateField(element: HTMLSelectElement, labelId: string) {
  const options = element.getElementsByTagName('option')
  const span = document.createElement('span')
  span.classList.add('text-danger')
  span.textContent = '*'
  const optionCount = options.length
  const stateLabel = document.querySelector(
    `label[for="${labelId}"]`,
  ) as HTMLLabelElement
  if (optionCount > 1) {
    element.setAttribute('required', '')
    const existingSpan = stateLabel.querySelector('.text-danger')
    if (!stateLabel.contains(existingSpan)) {
      stateLabel.appendChild(span)
    }
  } else {
    element.removeAttribute('required')
    const existingSpan = stateLabel.querySelector('.text-danger')
    if (existingSpan) {
      existingSpan.remove()
    }
  }
}

export { toggleStateField }
